module.exports = __webpack_public_path__ + "static/img/tonga-loko-junior-pasifiki.31bc660.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tonga-loko-junior-pasifiki.jpg
// module id = htpb
// module chunks = 0